// Reglas de los botones del Checklist (bloque 6): ítems automáticos (D) y
// "No aplica" manual (C, K3; Kevin 20 y 23/10/2026: "solo en este punto").

import { fechaEc } from './fechas';

// ── D. Ítems que escribe un sync: manda el módulo ───────────────────────────

export interface ReglaAutomatica {
  modulo: string;      // nombre del módulo (como modulo_storsafe del motor)
  regla: string;       // cuándo el sync marca "Cumple"
}

// Lote E: PO-09, PO-10, PO-12 y PO-13 salen de esta lista: los calcula Incidentes (incidentes/inc-checklist.ts) con la
// regla del estado manual (se pueden marcar a mano y el Checklist muestra el cálculo con "Usar cálculo automático").
// M61 (TH 5): la regla la aplica licencias-conduccion.ts (aquí solo el texto, sin Supabase).
export const REGLA_TH05 = 'cada trabajador activo de los puestos que operan vehículos o maquinaria tiene al menos una licencia de conducción de un tipo que su puesto acepta, vigente hoy (fecha de Ecuador); si a alguno le falta o la tiene vencida, En proceso';

function reglaInspeccionFirmada(item: string, plantilla: string): string {
  return `la última inspección firmada y vigente con las preguntas de ${item} (plantilla "${plantilla}") tiene todas sus respuestas en Cumple, o en No cumple con el hallazgo cerrado; una falla con el hallazgo abierto en plazo deja En proceso y una vencida o sin hallazgo, No cumple`;
}

export const ITEMS_AUTOMATICOS: Record<string, ReglaAutomatica> = {
  'GA-02': { modulo: 'Documentos SSO', regla: 'el RHS aprobado está subido en Documentos SSO, vigente y sin vencer' },
  'PO-07': { modulo: 'Incidentes', regla: 'hay al menos un incidente registrado' },
  'PO-08': { modulo: 'Incidentes', regla: 'hay una investigación completa (investigador, fecha, causa inmediata, acciones correctivas y testigos)' },
  'GT-02': { modulo: 'Puestos de Trabajo', regla: 'todos los puestos tienen trabajadores, horas, actividades, recursos y materiales' },
  'GT-08': { modulo: 'Matriz de Riesgos', regla: 'todas las evaluaciones tienen el riesgo residual calculado' },
  // Lote D (M49): con procedimientos de trabajos especiales, GT 37 lo calcula informes-puesto/ip-checklist.ts.
  'GT-09': { modulo: 'Permisos de Trabajo', regla: 'cada tipo de permiso usado en los últimos 12 meses tiene su procedimiento aprobado y socializado con firmas; si la empresa todavía no tiene procedimientos, hay al menos un permiso de cada uno de los 9 tipos' },
  'GT-10': { modulo: 'Permisos de Trabajo', regla: 'hay al menos un permiso activo o cerrado' },
  'GT-11': { modulo: 'Permisos de Trabajo', regla: 'hay un permiso cerrado con firma de cierre y el checklist completo sin "No cumple"' },
  'GT-12': { modulo: 'Productos', regla: 'todos los productos activos tienen su hoja de seguridad (SDS)' },
  'GT-13': { modulo: 'Etiquetado SGA', regla: 'todos los productos activos tienen su etiqueta SGA en PDF' },
  'GT-14': { modulo: 'Inspecciones', regla: 'hay una inspección del motor nuevo firmada y vigente con la pregunta de GT 9 que cumple; si no la hay, una inspección finalizada del módulo anterior con todas las preguntas respondidas' },
  // Etapa 5a (M60): los calcula Inspecciones v2 con la última inspección firmada y vigente (insp-anexo1.ts, regla del lote A).
  'GT-40': { modulo: 'Inspecciones', regla: reglaInspeccionFirmada('GT 13', 'Almacenamiento de productos químicos') },
  'GT-41': { modulo: 'Inspecciones', regla: reglaInspeccionFirmada('GT 18', 'Bioseguridad y control de plagas') },
  'GT-42': { modulo: 'Inspecciones', regla: reglaInspeccionFirmada('GT 19', 'Bioseguridad y control de plagas') },
  'GT-43': { modulo: 'Inspecciones', regla: reglaInspeccionFirmada('GT 20', 'Bioseguridad y control de plagas') },
  'GT-44': { modulo: 'Inspecciones', regla: reglaInspeccionFirmada('GT 23', 'Circulación, máquinas y rampas') },
  'GT-45': { modulo: 'Inspecciones', regla: reglaInspeccionFirmada('GT 24', 'Circulación, máquinas y rampas') },
  'GT-46': { modulo: 'Inspecciones', regla: reglaInspeccionFirmada('GT 25', 'Circulación, máquinas y rampas') },
  // M61 (TH 5): licencias de conducción por puesto y trabajador (licencias-conduccion.ts).
  'TH-05': { modulo: 'Trabajadores', regla: REGLA_TH05 },
  'SP-09': { modulo: 'Inspecciones', regla: `${reglaInspeccionFirmada('SP 9', 'Anexo 1 · Servicios permanentes')} (luz eléctrica, ventilación, agua para el consumo humano, servicios higiénicos, comedores, y alojamiento y vestuarios separados para hombres y mujeres: cumple solo si todas cumplen)` },
};

/** Regla común de los syncs (sync-estados.ts, decisión de JC del 23/10/2026). */
export const REGLA_COMUN_AUTOMATICOS = 'Si hay datos que todavía no cumplen, queda En proceso; sin datos, Pendiente.';

export function esAutomatico(itemId: string): boolean {
  return Object.prototype.hasOwnProperty.call(ITEMS_AUTOMATICOS, itemId);
}

// ── C. "No aplica" manual ───────────────────────────────────────────────────

/** Agregar un ítem a esta lista basta para habilitar su botón "No aplica". */
export const ITEMS_NO_APLICA_MANUAL: string[] = ['GA-06'];

export const MIN_JUSTIFICACION_NO_APLICA = 20;

/** Solo el administrador de la empresa o el superadmin (también impersonando). */
export function puedeMarcarNoAplica(rol: string | null | undefined, impersonando: boolean): boolean {
  return impersonando || rol === 'admin' || rol === 'superadmin';
}

// ── Rol que puede cambiar el Checklist (bloque 9, M19, §17 ítem 117) ────────
// En la base, INSERT/UPDATE/DELETE de checklist_item_estados quedan para el
// admin y el manager de la empresa y el superadmin. El viewer solo mira.

/** ¿Puede cambiar estados (a mano) y entrar al Checklist? Admin, manager o superadmin (también impersonando). */
export function puedeEditarChecklist(rol: string | null | undefined, impersonando: boolean): boolean {
  return impersonando || rol === 'admin' || rol === 'manager' || rol === 'superadmin';
}

/**
 * ¿Corren los syncs al abrir el Checklist? Todos salvo el viewer. Mientras el
 * perfil carga (rol null) se corren: si el rol no puede escribir, la base lo
 * rechaza y el sync no cambia nada.
 */
export function sincronizaChecklist(rol: string | null | undefined): boolean {
  return rol !== 'viewer';
}

/** ¿Se muestra la entrada al Checklist (ruta y botón "Ver en el Checklist")? Igual que puedeEditarChecklist, pero sin perfil todavía no se bloquea. */
export function puedeVerChecklist(rol: string | null | undefined, impersonando: boolean): boolean {
  return rol == null || puedeEditarChecklist(rol, impersonando);
}

/**
 * ¿Se muestra el botón "No aplica" manual? Solo en los ítems de la lista que el
 * perfil hace aplicar: un N/A automático (aplica = false) no se cambia a mano.
 */
export function muestraBotonNoAplica(item: { id: string; aplica: boolean; sin_calcular?: boolean }): boolean {
  return ITEMS_NO_APLICA_MANUAL.includes(item.id) && item.aplica && !item.sin_calcular;
}

/** Mensaje de error o null si la justificación sirve (mínimo 20 caracteres sin contar espacios de los extremos). */
export function validarJustificacionNoAplica(texto: string): string | null {
  const t = texto.trim();
  if (t.length === 0) return 'Escribe la justificación.';
  if (t.length < MIN_JUSTIFICACION_NO_APLICA) {
    return `La justificación debe tener al menos ${MIN_JUSTIFICACION_NO_APLICA} caracteres (lleva ${t.length}).`;
  }
  return null;
}

/** Texto del N/A manual: "No aplica (marcado por <nombre>, <fecha>): <justificación>". */
export function textoNoAplicaManual(nombre: string | null, fechaISO: string | null, justificacion: string): string {
  const fecha = fechaISO ? fechaEc(fechaISO) : 'sin fecha';   // ítem 190: día de Ecuador, no el de la zona del equipo
  return `No aplica (marcado por ${nombre || 'usuario sin nombre'}, ${fecha}): ${justificacion}`;
}
